import { reactive, computed } from 'vue'

export const campaignDataState = reactive({
  currentCampaignId: null,
  campaignData: null,
  rewardsData: [],
  newsUpdates: [],
  faqsData: [],

  loading: {
    campaign: false,
    rewards: false,
    news: false,
    faqs: false
  },

  errors: {
    campaign: null,
    rewards: null,
    news: null,
    faqs: null
  },

  // News 相關全局狀態
  newsViewMode: 'list', // list | detail | comments
  selectedNewsUpdate: null,

  // 獎勵數量全局狀態 (購物車)
  rewardQuantities: {},
})

export const campaignComputed = {
  isBasicDataReady: computed(() => {
    return !!(campaignDataState.campaignData && campaignDataState.rewardsData)
  }),

  isAnyLoading: computed(() => {
    return Object.values(campaignDataState.loading).some(Boolean)
  }),

  hasErrors: computed(() => {
    return Object.values(campaignDataState.errors).some(error => error !== null)
  }),

  allErrors: computed(() => {
    return Object.entries(campaignDataState.errors)
      .filter(([, error]) => error !== null)
  }),

  isLoading: (dataType) => computed(() => {
    return campaignDataState.loading[dataType] || false
  }),

  loadingTypes: computed(() => {
    return Object.keys(campaignDataState.loading)
      .filter(key => campaignDataState.loading[key])
  }),

  // News 相關 computed
  totalQuantity: computed(() => {
    return Object.values(campaignDataState.rewardQuantities)
      .reduce((sum, qty) => sum + (qty || 0), 0)
  })
}

export const campaignActions = {
  setCampaignId(campaignId) {
    if (campaignDataState.currentCampaignId !== campaignId) {
      this.clearData()
      campaignDataState.currentCampaignId = campaignId
    }
  },

  setLoading(dataType, isLoading) {
    campaignDataState.loading[dataType] = isLoading
  },

  setError(dataType, error) {
    campaignDataState.errors[dataType] = error
    if (error) {
      console.error(`❌ ${dataType} error:`, error)
    }
  },

  setData(dataType, data) {
    switch (dataType) {
      case 'campaign':
        campaignDataState.campaignData = data
        break
      case 'rewards':
        campaignDataState.rewardsData = Array.isArray(data) ? data : []
        break
      case 'news':
        campaignDataState.newsUpdates = Array.isArray(data) ? data : []
        break
      case 'faqs':
        campaignDataState.faqsData = Array.isArray(data) ? data : []
        break
      default:
        console.warn(`Unknown data type: ${dataType}`)
        return
    }
    this.setError(dataType, null)
  },

  getData(dataType) {
    switch (dataType) {
      case 'campaign':
        return campaignDataState.campaignData
      case 'rewards':
        return campaignDataState.rewardsData
      case 'news':
        return campaignDataState.newsUpdates
      case 'faqs':
        return campaignDataState.faqsData
      default:
        console.warn(`Unknown data type: ${dataType}`)
        return null
    }
  },

  hasData(dataType) {
    const data = this.getData(dataType)
    if (Array.isArray(data)) {
      return data.length > 0 // 只有非空陣列才算有數據
    }
    return data !== null && data !== undefined
  },

  clearData() {
    campaignDataState.campaignData = null
    campaignDataState.rewardsData = []
    campaignDataState.newsUpdates = []
    campaignDataState.faqsData = []

    // 清空 News 和獎勵狀態
    campaignDataState.newsViewMode = 'list'
    campaignDataState.selectedNewsUpdate = null
    campaignDataState.rewardQuantities = {}

    Object.keys(campaignDataState.loading).forEach(key => {
      campaignDataState.loading[key] = false
    })

    Object.keys(campaignDataState.errors).forEach(key => {
      campaignDataState.errors[key] = null
    })
  },

  clearDataType(dataType) {
    this.setData(dataType, dataType === 'campaign' ? null : [])
  },

  getStateSummary() {
    return {
      campaignId: campaignDataState.currentCampaignId,
      hasData: {
        campaign: this.hasData('campaign'),
        rewards: this.hasData('rewards'),
        news: this.hasData('news'),
        faqs: this.hasData('faqs')
      }
    }
  },

  // News 狀態管理 actions
  setNewsViewMode(mode) {
    campaignDataState.newsViewMode = mode
  },

  setSelectedNewsUpdate(update) {
    campaignDataState.selectedNewsUpdate = update
  },

  // 獎勵數量管理 actions
  updateRewardQuantity(rewardId, quantity) {
    campaignDataState.rewardQuantities[rewardId] = quantity
  },

  clearRewardQuantities() {
    campaignDataState.rewardQuantities = {}
  }
}


